import { UniversalImporterJobCatalogTreePageDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import NuvoImporter from 'modules/universal_importer/components/NuvoImporter'

const UniversalImporterJobCatalogTreePage = () => {
  const {
    company,
    access: { locale },
  } = useCurrentSession()
  const { data, loading, error } = useQuery(UniversalImporterJobCatalogTreePageDocument, {
    variables: { companyId: company.id },
    fetchPolicy: 'network-only',
  })

  const legacyJobCatalogFeatureFlag = data?.features.featuresConnection.nodes.find(
    (featureFlag) => featureFlag.name === 'legacy_job_catalog'
  )
  const canImportResources = data?.universalImporter._policies.importResources.can

  const authorized = !legacyJobCatalogFeatureFlag?.enabled && canImportResources

  const { navigation } = useNavigation()

  return (
    <ResponsivePage.Body authorized={authorized} loading={loading} error={error} showHeader={false}>
      <NuvoImporter
        importType="job_catalog_tree_importer"
        locale={locale}
        companyId={company.id}
        customFinishNavigation={navigation.employees.jobCatalog.importInProgress.fullPath()}
      />
    </ResponsivePage.Body>
  )
}

export default UniversalImporterJobCatalogTreePage
